import {gsap} from "gsap";
import {isIpad, isMobile, isTablet} from "../helpers";

export function initPhonesEffects() {
    if (!$('#iphones_block').length) return;
    if (!isMobile() && !isTablet() && !isIpad()) {
        const tl1 = gsap.timeline({
            scrollTrigger: {
                trigger: $('.iphone-first-grid'),
                scroller: isMobile() || isTablet() ? '' : '.scroller',
                scrub: true,
                ease: 'none',
                start: 'top-=150% bottom',
                invalidateOnRefresh: true,
            },
        }).from($('.iphone-first-grid .front-iphone'), {
            translateY: '30%',
            willChange: 'transform',
            duration: 0.5,
        }).to($('.iphone-first-grid .front-iphone'), {
            translateY: '-15%',
            willChange: 'auto'
        })

        const tl2 = gsap.timeline({
            scrollTrigger: {
                trigger: $('.iphone-first-grid'),
                scroller: isMobile() || isTablet() ? '' : '.scroller',
                scrub: true,
                ease: 'none',
                start: 'top-=150% bottom',
                invalidateOnRefresh: true,
            },
        }).from($('.iphone-first-grid .back-iphone'), {
            translateY: '30%',
            willChange: 'transform',
            duration: 0.6,
        })

        const tl4 = gsap.timeline({
            scrollTrigger: {
                trigger: $('.iphone-second-grid .iphone-grid'),
                scroller: isMobile() || isTablet() ? '' : '.scroller',
                start: 'top-=150% bottom',
                scrub: true,
                ease: "none",
                invalidateOnRefresh: true,
            },
        }).from($('.iphone-second-grid .front-iphone'), {
            translateY: '0%',
            willChange: 'transform',
        }).to($('.iphone-second-grid .front-iphone'), {
            translateY: '-50%',
            willChange: 'auto'
        })

        const tl5 = gsap.timeline({
            scrollTrigger: {
                trigger: $('.iphone-second-grid .iphone-grid'),
                scroller: isMobile() || isTablet() ? '' : '.scroller',
                start: 'top-=150% bottom',
                scrub: true,
                ease: "none",
                invalidateOnRefresh: true,
            },
        }).from($('.iphone-second-grid .back-iphone'), {
            translateY: '30%',
            willChange: 'transform',
        })

        const tl6 = gsap.timeline({
            scrollTrigger: {
                trigger: $('.iphone-third-grid .iphone-grid'),
                scroller: isMobile() || isTablet() ? '' : '.scroller',
                start: 'top-=150% bottom',
                scrub: true,
                ease: "none",
                invalidateOnRefresh: true,
            },
        }).from($('.iphone-third-grid .back-iphone'), {
            translateY: '0%',
            willChange: 'transform',
        }).to($('.iphone-third-grid .back-iphone'), {
            translateY: '-50%',
            willChange: 'auto'
        })

        const tl7 = gsap.timeline({
            scrollTrigger: {
                trigger: $('.iphone-third-grid .iphone-grid'),
                scroller: isMobile() || isTablet() ? '' : '.scroller',
                start: 'top-=150% bottom',
                scrub: true,
                ease: "none",
                invalidateOnRefresh: true,
            },
        }).from($('.iphone-third-grid .middle-iphone'), {
            translateY: '0%',
            willChange: 'transform',
        }).to($('.iphone-third-grid .middle-iphone'), {
            translateY: '-80%',
            willChange: 'auto'
        })

        const tl8 = gsap.timeline({
            scrollTrigger: {
                trigger: $('.iphone-third-grid .iphone-grid'),
                scroller: isMobile() || isTablet() ? '' : '.scroller',
                start: 'top-=150% bottom',
                scrub: true,
                ease: "none",
                invalidateOnRefresh: true,
            },
        }).from($('.iphone-third-grid .front-iphone'), {
            translateY: 0,
            willChange: 'transform',
        }).to($('.iphone-third-grid .front-iphone'), {
            translateY: '-20%',
            willChange: 'auto'
        })

        const tl9 = gsap.timeline({
            scrollTrigger: {
                trigger: $('.iphone-third-grid .iphone-grid'),
                scroller: isMobile() || isTablet() ? '' : '.scroller',
                start: 'top-=150% bottom',
                scrub: true,
                ease: "none",
                invalidateOnRefresh: true,
            },
        }).from($('.iphone-third-grid .iphone-text'), {
            translateY: '-20%',
            willChange: 'transform',
        }).to($('.iphone-third-grid .iphone-text'), {
            translateY: '50%',
            willChange: 'auto'
        })

        $(window).on('load', () => {
            const t3 = gsap.timeline({
                scrollTrigger: {
                    trigger: $('.iphone-hand-wrapper').parents('.section'),
                    scroller: isMobile() || isTablet() ? '' : '.scroller',
                    scrub: true,
                    start: 'top +=300%',
                    ease: "none",
                    invalidateOnRefresh: true,
                },
            }).from($('.iphone-hand-wrapper .iphone-hand'), {
                rotateZ: '25',
                transformOrigin: 'left bottom',
                willChange: 'transform'
            }).to($('.iphone-hand-wrapper .iphone-hand'), {
                rotateZ: '0',
                transformOrigin: 'left bottom',
                willChange: 'auto'
            })
        })
    }
}


export function initBeelinePhonesEffects() {
    if (!$('#beeline_iphones_block').length) return;

    if (!isMobile() && !isTablet()) {
        const firstCenter = gsap.timeline({
            scrollTrigger: {
                trigger: $('.beeline-iphones.first'),
                scroller: isMobile() || isTablet() ? '' : '.scroller',
                scrub: true,
                ease: 'none',
                start: 'top-=150% bottom',
                invalidateOnRefresh: true,
            },
        }).from($('.beeline-iphones.first .center-iphone'), {
            translateY: '30%',
            willChange: 'transform',
            duration: 0.5,
        }).to($('.beeline-iphones.first .center-iphone'), {
            translateY: '-15%',
            willChange: 'auto'
        })

        const firstLeft = gsap.timeline({
            scrollTrigger: {
                trigger: $('.beeline-iphones.first'),
                scroller: isMobile() || isTablet() ? '' : '.scroller',
                scrub: true,
                ease: 'none',
                start: 'top-=150% bottom',
                invalidateOnRefresh: true,
            },
        }).from($('.beeline-iphones.first .left-iphone'), {
            translateY: '15%',
            willChange: 'transform',
            duration: 0.6,
        })

        const firstRight = gsap.timeline({
            scrollTrigger: {
                trigger: $('.beeline-iphones.first'),
                scroller: isMobile() || isTablet() ? '' : '.scroller',
                scrub: true,
                ease: 'none',
                start: 'top-=150% bottom',
                invalidateOnRefresh: true,
            },
        }).from($('.beeline-iphones.first .right-iphone'), {
            translateY: '35%',
            willChange: 'transform',
            duration: 0.6,
        })

        const secondCenter = gsap.timeline({
            scrollTrigger: {
                trigger: $('.beeline-iphones.second'),
                scroller: isMobile() || isTablet() ? '' : '.scroller',
                start: 'top-=150% bottom',
                scrub: true,
                ease: "none",
                invalidateOnRefresh: true,
            },
        }).from($('.beeline-iphones.second .center-iphone'), {
            translateY: '40%',
            willChange: 'transform',
        }).to($('.beeline-iphones.second .center-iphone'), {
            translateY: '-10%',
            willChange: 'auto'
        })

        const secondRight = gsap.timeline({
            scrollTrigger: {
                trigger: $('.beeline-iphones.second'),
                scroller: isMobile() || isTablet() ? '' : '.scroller',
                start: 'top-=150% bottom',
                scrub: true,
                ease: "none",
                invalidateOnRefresh: true,
            },
        }).from($('.beeline-iphones.second .right-iphone'), {
            translateY: '30%',
            willChange: 'transform',
        })

        const thirdLeft = gsap.timeline({
            scrollTrigger: {
                trigger: $('.beeline-iphones.third'),
                scroller: isMobile() || isTablet() ? '' : '.scroller',
                start: 'top-=150% bottom',
                scrub: true,
                ease: "none",
                invalidateOnRefresh: true,
            },
        }).from($('.beeline-iphones.third .left-iphone'), {
            translateY: '60%',
            willChange: 'transform',
        })

        const thirdCenter = gsap.timeline({
            scrollTrigger: {
                trigger: $('.beeline-iphones.third'),
                scroller: isMobile() || isTablet() ? '' : '.scroller',
                start: 'top-=150% bottom',
                scrub: true,
                ease: "none",
                invalidateOnRefresh: true,
            },
        }).from($('.beeline-iphones.third .center-iphone'), {
            translateY: '20%',
            willChange: 'transform',
        }).to($('.beeline-iphones.third .center-iphone'), {
            translateY: '-10%',
            willChange: 'auto'
        })

        const thirdRight = gsap.timeline({
            scrollTrigger: {
                trigger: $('.beeline-iphones.third'),
                scroller: isMobile() || isTablet() ? '' : '.scroller',
                start: 'top-=150% bottom',
                scrub: true,
                ease: "none",
                invalidateOnRefresh: true,
            },
        }).from($('.beeline-iphones.third .right-iphone'), {
            translateY: '30%',
            willChange: 'transform',
        })
    }
}


export function initVolgaCliffPhonesEffects() {
    if (!$('#volgacliff_iphones_block').length) return;

    if (!isMobile() && !isTablet()) {
        const firstCenter = gsap.timeline({
            scrollTrigger: {
                trigger: $('.volgacliff-iphones.first'),
                scroller: isMobile() || isTablet() ? '' : '.scroller',
                scrub: true,
                ease: 'none',
                start: 'top-=150% bottom',
                invalidateOnRefresh: true,
            },
        }).from($('.volgacliff-iphones.first .center-iphone'), {
            translateY: '30%',
            willChange: 'transform',
            duration: 0.5,
        }).to($('.volgacliff-iphones.first .center-iphone'), {
            translateY: '-15%',
            willChange: 'auto'
        })

        const firstLeft = gsap.timeline({
            scrollTrigger: {
                trigger: $('.volgacliff-iphones.first'),
                scroller: isMobile() || isTablet() ? '' : '.scroller',
                scrub: true,
                ease: 'none',
                start: 'top-=150% bottom',
                invalidateOnRefresh: true,
            },
        }).from($('.volgacliff-iphones.first .left-iphone'), {
            translateY: '20%',
            willChange: 'transform',
            duration: 0.6,
        })

        const firstRight = gsap.timeline({
            scrollTrigger: {
                trigger: $('.volgacliff-iphones.first'),
                scroller: isMobile() || isTablet() ? '' : '.scroller',
                scrub: true,
                ease: 'none',
                start: 'top-=150% bottom',
                invalidateOnRefresh: true,
            },
        }).from($('.volgacliff-iphones.first .right-iphone'), {
            translateY: '5%',
            willChange: 'transform',
            duration: 0.6,
        })

        const secondCenter = gsap.timeline({
            scrollTrigger: {
                trigger: $('.volgacliff-iphones.second'),
                scroller: isMobile() || isTablet() ? '' : '.scroller',
                start: 'top-=150% bottom',
                scrub: true,
                ease: "none",
                invalidateOnRefresh: true,
            },
        }).from($('.volgacliff-iphones.second .center-iphone'), {
            translateY: '40%',
            willChange: 'transform',
        }).to($('.volgacliff-iphones.second .center-iphone'), {
            translateY: '-10%',
            willChange: 'auto'
        })

        const secondRight = gsap.timeline({
            scrollTrigger: {
                trigger: $('.volgacliff-iphones.second'),
                scroller: isMobile() || isTablet() ? '' : '.scroller',
                start: 'top-=150% bottom',
                scrub: true,
                ease: "none",
                invalidateOnRefresh: true,
            },
        }).from($('.volgacliff-iphones.second .right-iphone'), {
            translateY: '60%',
            willChange: 'transform',
        })

        const thirdLeft = gsap.timeline({
            scrollTrigger: {
                trigger: $('.volgacliff-iphones.third'),
                scroller: isMobile() || isTablet() ? '' : '.scroller',
                start: 'top-=150% bottom',
                scrub: true,
                ease: "none",
                invalidateOnRefresh: true,
            },
        }).from($('.volgacliff-iphones.third .left-iphone'), {
            translateY: '60%',
            willChange: 'transform',
        })

        const thirdCenter = gsap.timeline({
            scrollTrigger: {
                trigger: $('.volgacliff-iphones.third'),
                scroller: isMobile() || isTablet() ? '' : '.scroller',
                start: 'top-=150% bottom',
                scrub: true,
                ease: "none",
                invalidateOnRefresh: true,
            },
        }).from($('.volgacliff-iphones.third .center-iphone'), {
            translateY: '30%',
            willChange: 'transform',
        }).to($('.volgacliff-iphones.third .center-iphone'), {
            translateY: '0',
            willChange: 'auto'
        })

        const thirdRight = gsap.timeline({
            scrollTrigger: {
                trigger: $('.volgacliff-iphones.third'),
                scroller: isMobile() || isTablet() ? '' : '.scroller',
                start: 'top-=150% bottom',
                scrub: true,
                ease: "none",
                invalidateOnRefresh: true,
            },
        }).from($('.volgacliff-iphones.third .right-iphone'), {
            translateY: '20%',
            willChange: 'transform',
        })
    }
}

export function initReservPhonesEffects() {
    if (!$('#reserv_iphones_block').length) return;

    if (!isMobile() && !isTablet()) {
        const firstCenter = gsap.timeline({
            scrollTrigger: {
                trigger: $('.reserv-iphones.first'),
                scroller: isMobile() || isTablet() ? '' : '.scroller',
                scrub: true,
                ease: 'none',
                start: 'top-=150% bottom',
                invalidateOnRefresh: true,
            },
        }).from($('.reserv-iphones.first .center-iphone'), {
            translateY: '10%',
            willChange: 'transform',
            duration: 0.5,
        }).to($('.reserv-iphones.first .center-iphone'), {
            translateY: '-15%',
            willChange: 'auto'
        })

        const firstLeft = gsap.timeline({
            scrollTrigger: {
                trigger: $('.reserv-iphones.first'),
                scroller: isMobile() || isTablet() ? '' : '.scroller',
                scrub: true,
                ease: 'none',
                start: 'top-=150% bottom',
                invalidateOnRefresh: true,
            },
        }).from($('.reserv-iphones.first .left-iphone'), {
            translateY: '15%',
            willChange: 'transform',
            duration: 0.6,
        })

        const secondCenter = gsap.timeline({
            scrollTrigger: {
                trigger: $('.reserv-iphones.second'),
                scroller: isMobile() || isTablet() ? '' : '.scroller',
                start: 'top-=150% bottom',
                scrub: true,
                ease: "none",
                invalidateOnRefresh: true,
            },
        }).from($('.reserv-iphones.second .center-iphone'), {
            translateY: '30%',
            willChange: 'transform',
        }).to($('.reserv-iphones.second .center-iphone'), {
            translateY: '-10%',
            willChange: 'auto'
        })

        const secondRight = gsap.timeline({
            scrollTrigger: {
                trigger: $('.reserv-iphones.second'),
                scroller: isMobile() || isTablet() ? '' : '.scroller',
                start: 'top-=150% bottom',
                scrub: true,
                ease: "none",
                invalidateOnRefresh: true,
            },
        }).from($('.reserv-iphones.second .right-iphone'), {
            translateY: '30%',
            willChange: 'transform',
        })

        const thirdLeft = gsap.timeline({
            scrollTrigger: {
                trigger: $('.reserv-iphones.third'),
                scroller: isMobile() || isTablet() ? '' : '.scroller',
                start: 'top-=150% bottom',
                scrub: true,
                ease: "none",
                invalidateOnRefresh: true,
            },
        }).from($('.reserv-iphones.third .left-iphone'), {
            translateY: '60%',
            willChange: 'transform',
        })

        const thirdCenter = gsap.timeline({
            scrollTrigger: {
                trigger: $('.reserv-iphones.third'),
                scroller: isMobile() || isTablet() ? '' : '.scroller',
                start: 'top-=150% bottom',
                scrub: true,
                ease: "none",
                invalidateOnRefresh: true,
            },
        }).from($('.reserv-iphones.third .center-iphone'), {
            translateY: '60%',
            willChange: 'transform',
        }).to($('.reserv-iphones.third .center-iphone'), {
            translateY: '-10%',
            willChange: 'auto'
        })

        const fouthCenter = gsap.timeline({
            scrollTrigger: {
                trigger: $('.reserv-iphones.fouth'),
                scroller: isMobile() || isTablet() ? '' : '.scroller',
                start: 'top-=150% bottom',
                scrub: true,
                ease: "none",
                invalidateOnRefresh: true,
            },
        }).from($('.reserv-iphones.fouth .center-iphone'), {
            translateY: '20%',
            willChange: 'transform',
        }).to($('.reserv-iphones.fouth .center-iphone'), {
            translateY: '-10%',
            willChange: 'auto'
        })

        const fouthRight = gsap.timeline({
            scrollTrigger: {
                trigger: $('.reserv-iphones.fouth'),
                scroller: isMobile() || isTablet() ? '' : '.scroller',
                start: 'top-=150% bottom',
                scrub: true,
                ease: "none",
                invalidateOnRefresh: true,
            },
        }).from($('.reserv-iphones.fouth .right-iphone'), {
            translateY: '20%',
            willChange: 'transform',
        }).to($('.reserv-iphones.fouth .right-iphone'), {
            translateY: '-10%',
            willChange: 'auto'
        })
    }
}
